import { formFieldsGetters } from '@/store/modules/formFields/routines'

export default {
  [formFieldsGetters.LOAN_FORM_FIELDS]: state => state.loanFormFields,
  [formFieldsGetters.ENQUIRY_FORM_FIELDS]: state => state.enquiryFormFields,
  [formFieldsGetters.ENQUIRY_FORM_SECTIONS]: state => state.enquiryFormSections,
  [formFieldsGetters.GRANT_FORM_FIELDS]: state => state.grantFormFields,
  [formFieldsGetters.EQUITY_FORM_FIELDS]: state => state.equityFormFields
}
